$(function () {

    window.addEventListener("pageshow", function (event) {
        if (performance.navigation.type == 2) {
            // location.reload(true);
        }
    });

    // Redirect external links
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }

    // Smooth scroll
    $('body.page-template-product a[href*="#"]:not([href="#"]), body.page-template-index a[href*="#"]:not([href="#"])').click(function () {
        var offset = -200; // <-- change the value here
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top + offset
                }, 1000);
                return false;
            }
        }
    });

    if($("input.quantity__input").length){
        $("input.quantity__input").on("keypress keyup blur", function(event) {
            if (/^\d{0,2}(?:\.\d{0,8})?$/.test($(this).val())) {
                lastValid = $(this).val();
            } else {
                event.preventDefault();
                $(this).val(lastValid);
            }
        });
    }
    


    // $(window).scroll(function () {
    //     var header = $(".shopify-section--header");
    //     var home_header = $(".template-index .shopify-section--header");
    //     var announcement = $(".announcement-bar-section");
    //     var window_offset = $(window).scrollTop();

    //     if (window_offset >= 600) {
    //         // hehome_headerader.css({ 'position': 'fixed', 'top': '39px' })
    //         announcement.css('position', 'sticky')
    //     } else {
    //         // home_header.css({ 'position': 'relative', 'top': '0' })
    //         announcement.css('position', 'relative')
    //     }

    //     // if (window_offset > 800) {
    //     //     header.css('visibility', 'visible')
    //     // }
    //     // console.log(window_offset)
    // });

    if($('.text-slider').length){
        $('.text-slider').slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            draggable: false,
            swipe: false,
        });
    }
    

    if($('.accordion details').length){
        $('.accordion details').on('click', function () {
            $('.accordion details').not($(this).attr('id')).removeAttr('open')
            if ($(this).attr('open') == 'undefined') {
                $(this).removeAttr('open')
            }
        })
    }
    

    if($('#myInput').length){
        $('#myInput').on('keyup', function () {
            var value = $(this).val().toLowerCase();
            $('.accordion-item').filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });
    }
    

    if($('slider-component ul.collection-list').length){
        $('slider-component ul.collection-list').slick({
            // slidesToShow: 5,
            slidesToScroll: 2,
            swipeToSlide: true,
            autoplay: true,
            infinite: true,
            loop: true,
            autoplaySpeed: 8000,
            arrows: false,
            buttons: false,
            variableWidth: true,
            centerMode: false
        });
    }
    

    // if ($('.choice-container.mobile-version.style-1').length) {
    //     $('.choice-container.mobile-version.style-1').slick({
    //         slidesToShow: 1,
    //         autoplay: false,
    //         infinite: false,
    //         adaptiveHeight: true,
    //         loop: true,
    //         arrows: true,
    //         dots: false,
    //         variableWidth: true,
    //         centerMode: true,
    //         mobileFirst: true,
    //         centerPadding: '20px',
    //         responsive: [
    //             {
    //                 breakpoint: 768,
    //                 settings: 'unslick'
    //             }
    //         ]
    //     });
    // } 

    if ($('.fbt-section .fbt-products').length) {
        $('.fbt-section .fbt-products').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            autoplay: true,
            infinite: true,
            loop: true,
            autoplaySpeed: 8000,
            arrows: true,
            buttons: false,
            variableWidth: true,
            centerMode: true,
             centerPadding: '20px',
             responsive: [
                {
                    breakpoint: 750,
                    arrows: false,
                    buttons: true,
                }
            ]
        });
    }
    


    // $('.quantity__button, input.button-picker, .appstle_subscription_wrapper_option ').on('click', function () {
    if($('.quantity__button, input.button-picker ').length){
        $('.quantity__button, input.button-picker ').on('click', function () {
            var subtotal = "";

            if ($('.appstle_subscription_wrapper_option.appstle_include_dropdown').length) {
                if ($('.appstle_subscription_wrapper_option.appstle_include_dropdown').hasClass('appstle-active-option')) {
                    subtotal = parseFloat($('label[for="appstle_subscription_widget0-' + $('#appstle_selling_plan_label_20').val() + '"] .sellingplan .transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())

                } else {
                    subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())

                }
            } else {

                subtotal = parseFloat($('.price__regular .price-item.price-item--regular').attr('data-price').replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())

            }


            // if ($('.appstle_subscription_wrapper_option.appstle_include_dropdown').hasClass('appstle-active-option')) {
            //     subtotal = parseFloat($('label[for="appstle_subscription_widget0-' + $('#appstle_selling_plan_label_20').val() + '"] .sellingplan .transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())

            // } else {
            //     subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())

            // }

            console.log("Subtotal: " + subtotal)

            $('button.product-form__submit span.subtotal').remove();
            $('button.product-form__submit span').append('<span class="subtotal"> | ₱' + parseFloat(subtotal).toFixed(2) + ' </span>')
        })
    }
    


    $('.footer-block--menu .footer-block__heading').on('click', function () {
        $(this).toggleClass('open')
    })


    var x, i;
    /*find all elements with an "overlay" class:*/
    x = document.getElementsByClassName("img-comp-overlay");
    for (i = 0; i < x.length; i++) {
        /*once for each "overlay" element:
        pass the "overlay" element as a parameter when executing the compareImages function:*/
        compareImages(x[i]);
    }
    function compareImages(img) {
        var slider, img, clicked = 0, w, h;
        /*get the width and height of the img element*/
        w = img.offsetWidth;
        h = img.offsetHeight;
        /*set the width of the img element to 50%:*/
        img.style.width = (w / 2) + "px";
        /*create slider:*/
        slider = document.createElement("DIV");
        slider.setAttribute("class", "img-comp-slider");
        /*insert slider*/
        img.parentElement.insertBefore(slider, img);
        /*position the slider in the middle:*/
        slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
        slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
        /*execute a function when the mouse button is pressed:*/
        slider.addEventListener("mousedown", slideReady);
        /*and another function when the mouse button is released:*/
        window.addEventListener("mouseup", slideFinish);
        /*or touched (for touch screens:*/
        slider.addEventListener("touchstart", slideReady);
        /*and released (for touch screens:*/
        window.addEventListener("touchend", slideFinish);
        function slideReady(e) {
            /*prevent any other actions that may occur when moving over the image:*/
            e.preventDefault();
            /*the slider is now clicked and ready to move:*/
            clicked = 1;
            /*execute a function when the slider is moved:*/
            window.addEventListener("mousemove", slideMove);
            window.addEventListener("touchmove", slideMove);
        }
        function slideFinish() {
            /*the slider is no longer clicked:*/
            clicked = 0;
        }
        function slideMove(e) {
            var pos;
            /*if the slider is no longer clicked, exit this function:*/
            if (clicked == 0) return false;
            /*get the cursor's x position:*/
            pos = getCursorPos(e)
            /*prevent the slider from being positioned outside the image:*/
            if (pos < 0) pos = 0;
            if (pos > w) pos = w;
            /*execute a function that will resize the overlay image according to the cursor:*/
            slide(pos);
        }
        function getCursorPos(e) {
            var a, x = 0;
            e = (e.changedTouches) ? e.changedTouches[0] : e;
            /*get the x positions of the image:*/
            a = img.getBoundingClientRect();
            /*calculate the cursor's x coordinate, relative to the image:*/
            x = e.pageX - a.left;
            /*consider any page scrolling:*/
            x = x - window.pageXOffset;
            return x;
        }
        function slide(x) {
            /*resize the image:*/
            img.style.width = x + "px";
            /*position the slider:*/
            slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
        }
    }

    function waitForElement(id, callback) {
        var poops = setInterval(function () {
            if (document.getElementById('awt-product-data')) {
                clearInterval(poops);
                callback();
            }

            if (jQuery('.appstleRadioSellingPlanWrapper select[name="option"]').length < 1) {
                var $form = $('.appstleRadioSellingPlanWrapper');
                var $select = $('<select></select>').attr('name', 'option');

                jQuery('.appstleRadioSellingPlanWrapper select[name="option"]').val($('#appstle_selling_plan_label_20').val());

                $form.find('input[type="radio"]').each(function () {
                    var $radio = $(this);
                    var value = $radio.val();
                    var text = $radio.next('label').text().trim();
                    var $option = $('<option></option>').val(value).text(text);

                    $select.append($option);
                });

                $form.append($select);

                // if (jQuery('.product-form__input.meals-per-day-container').length) {
                //     jQuery('.product-form__input.meals-per-day-container .meal-type:first-child select').val(jQuery('select[name="options[Meal Plan Format]"]').val())
                // }


                $('select').on('change', function () {

                    // jQuery(".appstle-radio-input-wrapper input[value='" + this.value + "']").prop('checked', true);
                    jQuery(".appstle-radio-input-wrapper input[value='" + this.value + "']").trigger('click');

                    jQuery("#appstle_subscription_widget0").attr('data-selected-selling-plan', this.value)

                    jQuery('input#appstle_selling_plan_label_20').val(this.value);

                    // jQuery('.appstle_subscribe_option').trigger('change')

                    setTimeout(function () {
                        jQuery('.appstle-radio-input-wrapper label[for="' + $(".appstle-radio-input-wrapper input[value='" + this.value + "']").attr('id') + '"]').trigger('click')

                        var subtotal = "";
                        var customTotal = parseInt($('product-info .product-price').attr('data-custom')) * parseFloat($('product-info quantity-input input.quantity__input').val());
                        if ($('.appstle_subscription_wrapper_option.appstle_include_dropdown').hasClass('appstle-active-option')) {
                            if ($('.appstleRadioSellingPlanWrapper select[name="option"]').val() != null) {
                                // subtotal = parseFloat($('label[for="appstle_subscription_widget0-' + $('#appstle_selling_plan_label_20').val() + '"] .sellingplan .transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                                // subtotal = parseFloat($('label[for="appstle_subscription_widget0-' + $('#appstle_selling_plan_label_20').val() + '"] .sellingplan .transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                                subtotal = parseFloat($('.appstle_subscription_radio_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                             
                            } else {
                                setTimeout(
                                function() 
                                {
                                   subtotal = parseFloat($('.appstle_subscription_radio_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                                //    subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, ''))
                                  
                                }, 50);
                                
                            }
                        } else {
                            if ($('#appstle_subscription_widget0').length) {
                                subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                            } else {

                                subtotal = parseFloat($('product-info .product-price .price__regular .price-item').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())

                            }
                        }


                        // console.log("Select Custom total: " + + parseFloat(customTotal))
                        // console.log("Select: " + parseFloat(subtotal))

                        $('button.product-form__submit span.subtotal').remove();
                        $('button.product-form__submit span').append('<span class="subtotal"> | ₱' + parseFloat(subtotal + customTotal).toFixed(2) + ' </span>')

                    }, 500);
                });

                $('.appstle_subscription_wrapper_option').on('change', function () {

                    $('.appstleRadioSellingPlanWrapper select').val($('#appstle_selling_plan_label_20').val())

                    var subtotal = "";
                    var customTotal = parseInt($('product-info .product-price').attr('data-custom')) * parseFloat($('product-info quantity-input input.quantity__input').val());
                    if ($('.appstle_subscription_wrapper_option.appstle_include_dropdown').hasClass('appstle-active-option')) {
                        if ($('.appstleRadioSellingPlanWrapper select[name="option"]').val() != null) {
                        //     subtotal = parseFloat($('label[for="appstle_subscription_widget0-' + $('#appstle_selling_plan_label_20').val() + '"] .sellingplan .transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                        // } else {
                            subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                        }
                        
                    } else {
                        subtotal = parseFloat($('.appstle_subscription_radio_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
                    }


                    $('button.product-form__submit span.subtotal').remove();
                    $('button.product-form__submit span').append('<span class="subtotal"> | ₱' + parseFloat(subtotal + customTotal).toFixed(2) + ' </span>')
                    // console.log('subscription');



                })

            }
        }, 100);
    }

    if($('#appstle_subscription_widget0').length){
        waitForElement("#appstle_subscription_widget0", function () {

            if (jQuery('select[name="option"]').length < 1) {
                var $form = $('.appstleRadioSellingPlanWrapper');
                var $select = $('<select></select>').attr('name', 'option');

                $form.find('input[type="radio"]').each(function () {
                    var $radio = $(this);
                    var value = $radio.val();
                    var text = $radio.next('label').text().trim();
                    var $option = $('<option></option>').val(value).text(text);

                    $select.append($option);
                });

                $form.append($select);
            }


        });
    }

    
    $('.meal-type').on('click', function () {
      const $select = $(this).find('select');

      // Trigger change event on select
      $select.trigger('change');
    
      // Get the current value of the select
      const selectedValue = $select.val();
      // console.log('Selected value:', selectedValue);
      
      $(this).children('input').prop('checked', true)
      $('.product-form__input.product-form__input--dropdown div.select select[name="options[Meal Plan Format]"]').val(selectedValue);
  
    });
    
    $('.meal-type select').on('change', function () {
    // $('.meal-type button').on('click', function () {
        $(this).parent().parent().children('input').prop('checked', true)
        $('.meal-type button:not([value="'+$(this).attr('value')+'"])').removeClass('active')
        $(this).addClass('active')
        
        $('.product-form__input.product-form__input--dropdown div.select select[name="options[Meal Plan Format]"]').val(this.value);

        document.querySelector('select[name="options[Meal Plan Format]"]').value = this.value;
        document.querySelector('select[name="options[Meal Plan Format]"]').dispatchEvent(
            new Event("change", {
                bubbles: true,
                cancelable: true,
                view: window,
            })
        );
    });
    $('.meal-type:first-child').children('input').prop('checked', true)
    $('.meal-type label > div button:first-child').trigger('click')

    $('select[name="options[Meal Plan Format]').parent().parent().addClass('hidden')

    jQuery('.product-form__input.booking-form .buy-button form .booking-form input[name="properties[Date]"]').on('blur', function (e) {
        e.preventDefault()
        jQuery('.product-form__quantity + .buy-button form input[name="properties[Date]"').val($(this).val())

    })

    $('body.page-template-product ul.thumbnail-list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        // swipeToSlide: true,
        loop: true,
        infinite: false,
        autoplaySpeed: 8000,
        arrows: false,
        dots: false,
        variableWidth: false,
        centerMode: false,
        vertical: true,
        verticalSwiping: true
    });

    // if ($(window).width() <= 750) {
    $('.product__media-list.contains-media.slider.slider--mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        infinite: false,
        adaptiveHeight: true,
        loop: true,
        autoplaySpeed: 8000,
        arrows: false,
        dots: true,
        variableWidth: true,
        centerMode: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 750,
                settings: 'unslick'
            }
        ]
    });

    $('.multicolumn-list.contains-content-container.style-1.slider.slider--tablet, .multicolumn-list.contains-content-container.style1.slider.slider--tablet').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        // infinite: true,
        loop: false,
        autoplaySpeed: 8000,
        arrows: false,
        dots: false,
        variableWidth: true,
        mobileFirst: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 750,
                settings: 'unslick'
            }
        ]
    });

    $('.multicolumn-list.contains-content-container.style-2.slider, .multicolumn-list.contains-content-container.style2.slider').slick({
        // slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        // infinite: true,
        loop: true,
        autoplaySpeed: 8000,
        arrows: false,
        dots: true,
        // variableWidth: true,
        centerMode: false,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 750,
                settings: 'unslick'
            }
        ]
    });
    // }


    $("ul.multicolumn-list.mobile-dropwdown").click(function () {
        var is_open = $(this).hasClass("open");
        if (is_open) {
            $(this).removeClass("open");
        } else {
            $(this).addClass("open");
        }
    });

    $("ul.multicolumn-list.mobile-dropwdown li").click(function () {

        var selected_value = $(this).html();
        var first_li = $("ul.multicolumn-list.mobile-dropwdown li:first-child").html();

        $("ul.multicolumn-list.mobile-dropwdown li:first-child").html(selected_value);
        $(this).html(first_li);

    });

    $(document).mouseup(function (event) {

        var target = event.target;
        var select = $("ul.multicolumn-list.mobile-dropwdown");

        if (!select.is(target) && select.has(target).length === 0) {
            select.removeClass("open");
        }

    });


    setTimeout(() => {
        if (jQuery('form#ContactForm:has(.icon-success)').length) {
            window.location.replace("/pages/contact-us");
        }

    }, "3000");


    jQuery('.section-collapsible-content .accordion svg:not(#Group_6805)').on('click', function (e) {
        e.preventDefault();
        // jQuery(this).parent().next('.accordion__content').trigger('click')
        jQuery('details[open] .accordion__content').trigger('click')
    })

    jQuery('.jdgm-carousel__item-wrapper').slick({
        infinite: true,
        loop: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        swipeToSlide: true,
        // autoplay: true,
        // outerEdgeLimit: true,
        variableWidth: true,
        // responsive: [
        //     {
        //         breakpoint: 0,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1,
        //             arrows: true,
        //             centerMode: false,
        //             variableWidth: true,
        //             draggable: true
        //         },
        //     },
        //     {
        //         breakpoint: 800,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 1,
        //             arrows: true,
        //             centerMode: false,
        //             variableWidth: true,
        //             draggable: true
        //         },
        //     },
        //     {
        //         breakpoint: 1025,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 1,
        //             infinite: true,
        //             arrows: true,
        //             centerMode: true,
        //         },
        //     },
        // ],
    });

    $('ul.tabs li.active div.tab-title').css('background-color', $('ul.tabs li.active').children('.tab-title-container').attr('data-color'))
    // $('ul.tabs li.active .tab-title-container::before').css('background-color', $('ul.tabs li.active').children('.tab-title-container').attr('data-color'))
    $('ul.tabs li.active .tab-title-container').css('--tab-active', $('ul.tabs li.active').children('.tab-title-container').attr('data-color'))

    $('ul li').click(function () {

        tab_color = $(this).children('.tab-title-container').attr('data-color')

        $('ul li').prevUntil('li.active').addClass('highlight');
        $('li.active').nextAll('li').removeClass('highlight')

        // $('li.active.highlight').removeClass('highlight')
        $('li:not(:is(.active,.highlight ))  div.tab-title').css('background-color', '#88A1A8')
        $('li.active  div.tab-title, li.highlight  div.tab-title').css('background-color', tab_color)
        // $('ul.tabs li:is(.active,.highlight ) .tab-title-container::before').css('background-color', tab_color)
        $('ul.tabs li:is(.active,.highlight ) .tab-title-container').css('--tab-active', tab_color)

    });

    $('span.tab-next').on('click', function () {
        $('ul li.active').next('li').trigger('click')
    })
    $('span.tab-prev').on('click', function () {
        $('ul li.active:not(:first-child)').prev('li').trigger('click')
    })

    $('ul.multicolumn-list.contains-content-container.style-3').slick({
        // slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        // autoplay: true,
        infinite: false,
        loop: false,
        autoplaySpeed: 8000,
        arrows: true,
        dots: false,
        buttons: false,
        variableWidth: true,
        centerMode: false,
        mobileFirst: true,
        prevArrow: $('.multicolumn-list-heading-with-line .prev'),
        nextArrow: $('.multicolumn-list-heading-with-line .next'),
        responsive: [
            {
                breakpoint: 750,
                settings: 'unslick'
            }
        ]
    });

    // var totalPrice = 0;
    // document.querySelectorAll('div.cart__footer-wrapper .cart-item__totals:last-child .cart-item__price-wrapper .price.price--end').forEach(function (item) {
    //     totalPrice += parseFloat(item.textContent.trim().replace(",", ""))

    // });
    // console.log(totalPrice)

    // $('.cart__footer .totals .totals__total-value').text('₱' + totalPrice.toLocaleString())

    // jQuery('.template-product-custom-meal-plan .fullycustomized-container').removeClass('hidden')
    jQuery('.template-product-custom-meal-plan .quantity-with-cta').addClass('hidden')
    jQuery('.template-product-custom-meal-plan #trust-badge-content-div').addClass('hidden')
    jQuery('.template-product-custom-meal-plan variant-selects').addClass('hidden')
    jQuery('.template-product-custom-meal-plan .product-form__input.meals-per-day-container').addClass('hidden')
    jQuery('.template-product-custom-meal-plan .price ').addClass('hidden')
    jQuery('.template-product-custom-meal-plan .fullycustomized-container ').addClass('hidden')
    jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener ').addClass('hidden')
    jQuery('.template-product-custom-meal-plan .frequency_wrapper ').addClass('hidden')


    // Restrict Customizations value
    jQuery('#myDropdown label input').on('click', function(){
        if(jQuery('#myDropdown label input:is(:checked)').length == 3 ){
        // jQuery('#myDropdown label input[type="checkbox"]:not(:is(:checked))').attr('disabled', 'true')
            jQuery('#myDropdown.dropdown-content').removeClass('show')
            jQuery('body:not(.template-product-custom-meal-plan) .customized-plan').removeClass('hidden')

            jQuery('.template-product-custom-meal-plan .fullycustomized-container').removeClass('hidden')
            jQuery('.template-product-custom-meal-plan .quantity-with-cta').addClass('hidden')
            jQuery('.template-product-custom-meal-plan #trust-badge-content-div').addClass('hidden')

        }else if(jQuery('#myDropdown label input:is(:checked)').length == 2){

            jQuery('body:not(.template-product-custom-meal-plan) #myDropdown label input[type="checkbox"]:not(:is(:checked))').attr('disabled', 'true')
            
        }else{
            
            jQuery('body:not(.template-product-custom-meal-plan) #myDropdown label input[type="checkbox"]:not(:is(:checked))').removeAttr('disabled')
            jQuery('body:not(.template-product-custom-meal-plan) .customized-plan').addClass('hidden')
            
            jQuery('.template-product-custom-meal-plan .fullycustomized-container').addClass('hidden')
            jQuery('.template-product-custom-meal-plan .quantity-with-cta').removeClass('hidden')
            jQuery('.template-product-custom-meal-plan #trust-badge-content-div').removeClass('hidden')
        }
    })

    jQuery('button.new-user').on('click', function(){


        jQuery(this).addClass('current');
        // jQuery('button.existing-user').addClass('hidden')
        jQuery('button.existing-user').removeClass('current')

        jQuery('iframe.first-time-user').removeClass('hidden')

        jQuery('.template-product-custom-meal-plan .first-time-user').removeClass('hidden')

        jQuery('.template-product-custom-meal-plan .quantity-with-cta').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan #trust-badge-content-div').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan variant-selects').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .product-form__input.meals-per-day-container').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .price ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .fullycustomized-container ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .frequency_wrapper ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener[data-modal="#PopupModal-popup_rqwVdM"] ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener[data-modal="#PopupModal-popup_xCwnzz"] ').addClass('hidden')
        
    })

    jQuery('button.existing-user').on('click', function(){

        jQuery(this).addClass('current');
        // jQuery('button.new-user').addClass('hidden')
        jQuery('button.new-user').removeClass('current')

        jQuery('.template-product-custom-meal-plan .first-time-user').addClass('hidden')
        jQuery('.template-product-custom-meal-plan .quantity-with-cta').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan #trust-badge-content-div').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan variant-selects').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .product-form__input.meals-per-day-container').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .price ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .fullycustomized-container ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan .frequency_wrapper ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener[data-modal="#PopupModal-popup_xCwnzz"] ').removeClass('hidden')
        jQuery('.template-product-custom-meal-plan modal-opener.product-popup-modal__opener[data-modal="#PopupModal-popup_rqwVdM"] ').addClass('hidden')

    
    })

    jQuery('.custom-meal-trigger').on('click', function(){

        jQuery('body:not(.template-product-custom-meal-plan) .customized-plan').removeClass('hidden')

    })

    jQuery('.customized-plan > svg').on('click', function(){
        jQuery(this).parent().addClass('hidden')
    })

    jQuery('.customized-plan .cta p').on('click', function(){
        jQuery('body:not(.template-product-custom-meal-plan) .signature-meal-plan-customization').removeClass('hidden')
        jQuery('body:not(.template-product-custom-meal-plan) .customized-plan').addClass('hidden')
        jQuery('body:not(.template-product-custom-meal-plan) .no-customization-content > strong').addClass('hidden')
        jQuery('body:not(.template-product-custom-meal-plan) .no-customization-content > strong + p').addClass('hidden')
    })

    jQuery('.dropdown').mouseleave( function(){
        jQuery('#myDropdown').removeClass('show');
        // console.log("mouseleave");
    })


    //  jQuery('.dropdown').mouseover( function(){
        // jQuery('#myDropdown').addClass('show');
        // console.log("mouseover");
    // })

    if(jQuery('.customized-plan span').length){
        jQuery('.customized-plan span').on('click', function(){
            jQuery('.customized-plan').addClass('hidden');
        })
    }

    if(jQuery('select[name="options[Subscription Duration]"]').length){
        setTimeout(() => {
            jQuery('select[name="options[Subscription Duration]"]').trigger('change')
        }, 500);
    }
    
    if( jQuery('input[value="No customization"]').length){
        setTimeout(() => {
            jQuery('body:not(.template-product-custom-meal-plan)  input[value="No customization"]').trigger('click')
        }, 1000);
    }
    
    if(jQuery('.quantity-with-cta button.product-form__submit').length){
        jQuery('.quantity-with-cta button.product-form__submit').addClass('disabled')
    }
    
    if(jQuery('.quantity-with-cta button.product-form__submit').length){
        setTimeout(() => {
            jQuery('.quantity-with-cta button.product-form__submit').removeClass('disabled')
        }, 3000);
    }
  

    
    
    if(jQuery('select[name="options[Subscription Duration]"]').length){
        jQuery('select[name="options[Subscription Duration]"]').on('change', function(e) {
            // console.log("Right dropdown")

            $('.customization-container').attr('data-subtotal', 0)
            $('input.dropinput').val("")
            $('input.customization-info').val("")
            $('input.selected_variant_id').val("")
            $(".dropdown-content label input[type='checkbox']").prop('checked', false)

            let data_frequency_quantity = "";
            
            if(jQuery(this).find('option:selected').val().includes('1-week')){
                data_frequency_quantity = 1;
            }else if(jQuery(this).find('option:selected').val().includes('1 Week (Weekdays Only)')){
                data_frequency_quantity = 1;
            }else if(jQuery(this).find('option:selected').val().includes('1 Week')){
                data_frequency_quantity = 1;
            }else if(jQuery(this).find('option:selected').val().includes('2-weeks')){
                data_frequency_quantity = 2;
            }else if(jQuery(this).find('option:selected').val().includes('2 Weeks')){
                data_frequency_quantity = 2;
            }else if(jQuery(this).find('option:selected').val().includes('1-month')){
                data_frequency_quantity = 4;
            }else if(jQuery(this).find('option:selected').val().includes('1 Month')){
                data_frequency_quantity = 4;
            }else if(jQuery(this).find('option:selected').val().includes('3-months')){
                data_frequency_quantity = 12;
            }else if(jQuery(this).find('option:selected').val().includes('3 Months')){
                data_frequency_quantity = 12;
            }else if(jQuery(this).find('option:selected').val().includes('1-Day Trial')){
                data_frequency_quantity = 1;
            }else{
                data_frequency_quantity = 1;
            }
                
            // if(jQuery(this).find('option:selected').val().includes('5-days/week')){
            //     jQuery("#myDropdown label:not(:has(input[data-frequency='5 days'])):not(:has(input[value='No customization']))").addClass('hidden')
            //     jQuery("#myDropdown label:has(input[data-frequency='5 days'])").removeClass('hidden')
            
                
            //     jQuery("#myDropdown label:not(:has(input[data-frequency='5 days'])) input").removeAttr('data-quantity')
            //     jQuery("#myDropdown label:has(input[data-frequency='5 days']) input").attr('data-quantity', data_frequency_quantity)
            // }
            
            // if(jQuery(this).find('option:selected').val().includes('7-days/week')){
            //     jQuery("#myDropdown label:not(:has(input[data-frequency='7 days'])):not(:has(input[value='No customization']))").addClass('hidden')
            //     jQuery("#myDropdown label:has(input[data-frequency='7 days'])").removeClass('hidden')
            
            //         jQuery("#myDropdown label:not(:has(input[data-frequency='7 days'])) input").removeAttr('data-quantity')
            //     jQuery("#myDropdown label:has(input[data-frequency='7 days']) input").attr('data-quantity', data_frequency_quantity)
            // }

            // if(jQuery(this).find('option:selected').val().includes('Weekdays Only')){
            //     jQuery("#myDropdown label:not(:has(input[data-frequency='5 days'])):not(:has(input[value='No customization']))").addClass('hidden')
            //     jQuery("#myDropdown label:has(input[data-frequency='5 days'])").removeClass('hidden')
            
                
            //     jQuery("#myDropdown label:not(:has(input[data-frequency='5 days'])) input").removeAttr('data-quantity')
            //     jQuery("#myDropdown label:has(input[data-frequency='5 days']) input").attr('data-quantity', data_frequency_quantity)
            // }
            
            // if(jQuery(this).find('option:selected').val().includes('with Weekends')){
            //     jQuery("#myDropdown label:not(:has(input[data-frequency='7 days'])):not(:has(input[value='No customization']))").addClass('hidden')
            //     jQuery("#myDropdown label:has(input[data-frequency='7 days'])").removeClass('hidden')
            
            //         jQuery("#myDropdown label:not(:has(input[data-frequency='7 days'])) input").removeAttr('data-quantity')
            //     jQuery("#myDropdown label:has(input[data-frequency='7 days']) input").attr('data-quantity', data_frequency_quantity)
            // }

            if(jQuery(this).find('option:selected').val().includes('1-Day Trial')){
                jQuery("#myDropdown label:not(:has(input[data-frequency='Daily'])):not(:has(input[value='No customization']))").addClass('hidden')
                jQuery("#myDropdown label:has(input[data-frequency='Daily'])").removeClass('hidden')
            
                jQuery("#myDropdown label:not(:has(input[data-frequency='Daily'])) input").removeAttr('data-quantity')
                jQuery("#myDropdown label:has(input[data-frequency='Daily']) input").attr('data-quantity', data_frequency_quantity)
            }else{
                jQuery("#myDropdown label:has(input[data-frequency='Daily']):not(:has(input[value='No customization']))").addClass('hidden')
                jQuery("#myDropdown label:not(:has(input[data-frequency='Daily']))").removeClass('hidden')
            
                jQuery("#myDropdown label:has(input[data-frequency='Daily']) input").removeAttr('data-quantity')
                jQuery("#myDropdown label:not(:has(input[data-frequency='Daily'])) input").attr('data-quantity', data_frequency_quantity)
            }

            
        });
    }

    $(window).on("scroll", function() {
        var header = jQuery(".page-template-product #sticky-add-to-cart");
        var window_offset = jQuery(window).scrollTop();

        if(window_offset > 1144){
            header.removeClass('hidden')
        }else{
            header.addClass('hidden')
        }
    
    });

    jQuery('.see-more-faq').on('click', function(){
        var $target = $('.section-collapsible-content').first();
        $('html, body').animate({
        scrollTop: $target.offset().top - 150
    }, 600); // 600ms animation
    })



});



function toggleDropdown() {
    document.getElementById("myDropdown").classList.toggle("show");
}

function updateSelectedOptions(checkbox) {
    let selectedOptions = [];
    let selectedOptionsID = [];
    let totalOptions = 0;
    document.querySelectorAll('.dropdown-content input[type="checkbox"]').forEach(function (checkbox) {
        if (checkbox.checked) {

            if (checkbox.value == 'No customization') {

                jQuery('.product-form__input.customization .dropdown input:not([value="No customization"])').prop('checked', false)
                jQuery('.product-form__input.customization .dropdown label:has(input:not([value="No customization"]))').attr('disabled', true)
                // selectedOptions.push(checkbox.data('value'));
                selectedOptions.push(checkbox.value);
                // totalOptions = parseFloat(checkbox.dataset.price) * 0;

                $('.product-price').attr('data-custom', 0)
                $('.customization-value').val(0 + '00')
                $('.customization-container').attr('data-subtotal', 0)

            } else {

                // console.log(checkbox.dataset.value)
                selectedOptions.push(checkbox.dataset.value);
                selectedOptionsID.push(checkbox.value);
                
                if (checkbox.dataset.price != '') {
                    totalOptions += parseFloat(checkbox.dataset.price) * parseFloat(checkbox.dataset.quantity);
                }

                console.log("Total options: " + totalOptions);
            }
        } else {
            $('.product-price').attr('data-custom', totalOptions)
            $('.customization-value').val(totalOptions)
            $('.signature-meal-plan-customization .customization-container').attr('data-subtotal', totalOptions.toFixed(2))
            // console.log("Unchecked: " + totalOptions)
        }
    });

    var subtotal = "";
    var customTotal = totalOptions * parseFloat($('product-info quantity-input input.quantity__input').val());
    if ($('.appstle_subscription_wrapper_option.appstle_include_dropdown').hasClass('appstle-active-option')) {
        if ($('.appstleRadioSellingPlanWrapper select[name="option"]').val() != null) {
            subtotal = parseFloat($('label[for="appstle_subscription_widget0-' + $('#appstle_selling_plan_label_20').val() + '"] .sellingplan .transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
            console.log("IF: "+subtotal);
        } else {
            subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
            console.log("ELSE: "+subtotal);
        }
    } else {
        if ($('#appstle_subscription_widget0').length) {
            subtotal = parseFloat($('.appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
        } else {
            subtotal = parseFloat($('product-info .product-price .price__regular .price-item').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
            // setTimeout(() => {
            // subtotal = parseFloat($('product-info .product-price .price__regular .price-item').text().replace(/,/g, '')) * parseFloat($('product-info quantity-input input.quantity__input').val())
            // }, 1000);
        }

    }

    // console.log(subtotal)

    $('button.product-form__submit span.subtotal').remove();
    $('button.product-form__submit span').append('<span class="subtotal"> | ₱' + parseFloat(customTotal + subtotal).toLocaleString() + ' </span>')
    // console.log("Custom Total: " + parseFloat(customTotal + subtotal));

    $('.customization-info').val(selectedOptions.join(', '))

    if (totalOptions > 0) {
        $('.product-price').attr('data-custom', totalOptions)
        $('.customization-value').val(totalOptions + '00')
        $('.customization-container').attr('data-subtotal', totalOptions)
    }


    document.querySelector(".dropinput").value = selectedOptions.join(', ');
    document.querySelector(".selected_variant_id").value = selectedOptionsID.join(', ');
    // document.getElementById("selectedOptions").value = selectedOptions.join(', ');
}

// Close the dropdown if the user clicks outside of it
window.onclick = function (event) {
    if (!event.target.matches('.dropinput')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        for (var i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            // if (openDropdown.classList.contains('show')) {
            //     openDropdown.classList.remove('show');
            // }
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tabs li');
    const tabContents = document.querySelectorAll('.tab-pane');

    tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
            const targetTab = this.getAttribute('data-tab');

            tabs.forEach((item) => item.classList.remove('active'));
            tabContents.forEach((content) => content.classList.remove('active'));

            this.classList.add('active');
            document.getElementById(targetTab).classList.add('active');
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
    // Get all accordion buttons


    if (jQuery('.accordion-left-button').length) {
        var accordionButtons = document.querySelectorAll('.accordion-left-button');

        // Get the "VIEW ALL" button
        var viewAllButton = document.querySelector('.view-all-button');

        // Add the "active" class to the "VIEW ALL" button as the default active button
        viewAllButton.classList.add('active');

        // Add click event listener to each accordion button
        accordionButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                // Check if the clicked button is the "VIEW ALL" button
                var isViewAllButton = button.classList.contains('view-all-button');

                // Get the clicked button's ID
                var clickedButtonId = isViewAllButton ? null : button.id;

                // Log the clicked button's ID to the console
                console.log('Clicked button ID:', clickedButtonId);

                // Remove the "active" class from all accordion buttons
                accordionButtons.forEach(function (btn) {
                    btn.classList.remove('active');
                });

                // Add the "active" class to the clicked button
                button.classList.add('active');

                // Get all accordion items and headings
                var accordionItems = document.querySelectorAll('.accordion-item');
                var accordionHeadings = document.querySelectorAll('.faq-heading-wrapper');

                // Loop through all accordion items and headings
                accordionItems.forEach(function (item) {
                    if (isViewAllButton || item.id === clickedButtonId) {
                        // Show the accordion item with the matching ID or all items if "VIEW ALL" button is clicked
                        item.style.display = 'block';
                    } else {
                        // Hide other accordion items
                        item.style.display = 'none';
                    }
                });

                accordionHeadings.forEach(function (heading) {
                    if (isViewAllButton || heading.id === clickedButtonId) {
                        // Show the accordion heading with the matching ID or all headings if "VIEW ALL" button is clicked
                        heading.style.display = 'flex';

                        // Get the h2 element within the heading
                        var accordionHeading = heading.querySelector('h2');

                        // Add or remove the "active" class based on the button type
                        if (accordionHeading) {
                            if (isViewAllButton) {
                                accordionHeading.classList.remove('active');
                            } else {
                                accordionHeading.classList.add('active');
                            }
                        }
                    } else {
                        // Hide other accordion headings
                        heading.style.display = 'none';

                        // Remove the "active" class from h2 elements in other headings
                        var otherAccordionHeading = heading.querySelector('h2');
                        if (otherAccordionHeading) {
                            otherAccordionHeading.classList.remove('active');
                        }
                    }
                });
            });
        });
    }

    return true;


});
document.addEventListener('DOMContentLoaded', function () {
    function filterFAQ(faqCategory) {
        faqContents.forEach(function (content) {
            if (faqCategory === 'category-all') {
                content.style.display = 'block';
            } else {
                var faqCategoryClass = 'faq-category__' + faqCategory;
                if (content.classList.contains(faqCategoryClass)) {
                    content.style.display = 'block';
                } else {
                    content.style.display = 'none';
                }
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {

    if (jQuery('.accordion-button').length) {
        const accordionButtons = document.querySelectorAll('.accordion-button');

        // Open the first accordion item by default
        const firstContent = accordionButtons[0].nextElementSibling;
        firstContent.classList.add('show');
        const firstIcon = accordionButtons[0].querySelector('.icon');
        firstIcon.style.transform = 'rotate(0deg)';
        accordionButtons[0].classList.add('show'); // Add 'show' class to the first accordion button

        accordionButtons.forEach((button) => {
            button.addEventListener('click', function () {
                const content = this.nextElementSibling;
                const icon = this.querySelector('.icon');

                // Toggle the clicked accordion item
                if (this.classList.contains('show')) {
                    // Don't close the last open accordion item
                    // if (document.querySelectorAll('.accordion-content.show').length > 1) {
                    this.classList.remove('show');
                    icon.style.transform = 'rotate(180deg)';
                    this.classList.remove('show'); // Remove 'show' class from the accordion button
                    content.classList.remove('show');
                    // }
                } else {
                    // Close all accordion items except the clicked one
                    accordionButtons.forEach((otherButton) => {
                        if (otherButton !== this) {
                            const otherContent = otherButton.nextElementSibling;
                            const otherIcon = otherButton.querySelector('.icon');

                            otherContent.classList.remove('show');
                            otherIcon.style.transform = 'rotate(180deg)';
                            otherButton.classList.remove('show'); // Remove 'show' class from other accordion buttons
                        }
                    });

                    content.classList.add('show');
                    icon.style.transform = 'rotate(0deg)';
                    this.classList.add('show'); // Add 'show' class to the clicked accordion button
                }
            });
        });
    }


});


document.addEventListener("DOMContentLoaded", () => {
    const urlParams = new URLSearchParams(window.location.search);

    // Run only if the URL has at least one filter.p.product_type parameter
    if (urlParams.has("filter.p.product_type")) {
    // Get all product type values (multiple possible)
    const currentTypes = urlParams.getAll("filter.p.product_type").map(type => decodeURIComponent(type));
    const customFilter = document.querySelector(".custom-filter-item");

    if (customFilter && currentTypes.length > 0) {
        // Store all selected types in a data attribute (comma-separated)
        customFilter.setAttribute("data-product-type", currentTypes.join(", "));

        // Loop through each filter-item and highlight matching ones
        document.querySelectorAll(".filter-item").forEach(item => {
        const filterType = item.getAttribute("data-filter-type");
        if (filterType && currentTypes.includes(decodeURIComponent(filterType))) {
            item.classList.add("active-filter");
        } else {
            item.classList.remove("active-filter");
        }
        });
    }
    }


});